import {
  Routes,
  Route,
  Navigate,
  RouteProps,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import { useState } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-circular-progressbar/dist/styles.css";
// import SubscriptionPlans from "../components/SubscriptionPlans/SubscriptionPlans";
import Settings from "../pages/Settings/Settings";
import ExaminerSettings from "../pages/Examiner/ExaminerSettings/ExaminerSetting";
import StudyMaterialDetails from "../pages/Website/StudyMaterial/StudyMaterial";
import Mysubscription from "../pages/Mysubscription/Mysubscription";
import Joinexam from "../pages/Joinexam/Joinexam";
import Contact from "../pages/Contact/Contact";
import Terms from "../pages/Terms/Terms";
import CourseManagement from "../pages/CourseManagement/CourseManagement";
import AddLevels from "../pages/CourseManagement/AddLevels";
import CourseLessons from "../pages/CourseLessons/CourseLessons";
import Addlessons from "../pages/CourseLessons/AddLessons";
import { Question } from "react-bootstrap-icons";
import AddEditQuestion from "../pages/ManageQuestions/AddEditQuestion";
import TrainingAttemptPlayer from "../pages/AttemptPlayer/TrainingAttemptPlayer";
import Practise from "../pages/Website/Practise/Practise";
import AdminExaminerPayments from "../pages/AdminExaminerPayment/AdminExaminerPayment";
import ExamLiveQuestion from "../pages/LiveVFRQuestions/ExamLiveQuestions";
import Countries from "../pages/Countries/Countries";
import AddCountries from "../pages/Countries/AddCountries";
import Simulators from "../pages/Simulators/Simulators";
import AddSimulators from "../pages/Simulators/AddSimulator";
import AddUserSubscription from "../pages/Customers/AddUserSubscription";
import AddUserCertification from "../pages/Customers/AddUserCertification";
//import AddLiveQuestion from "../pages/LiveVFRQuestions/AddLiveQuestions";

const Navigation = () => {
  const isLoggedIn = !!localStorage.getItem("access_token");
  const userType = localStorage.getItem("type") ?? "";
  const appUsedFor = process.env.REACT_APP_USED_FOR;
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const LoginExaminer = React.lazy(
    () => import("../components/ExaminerLogin/ExaminerLogin")
  );

  const Signup = React.lazy(() => import("../components/Signup/Signup"));
  const SignupExaminer = React.lazy(
    () => import("../components/ExaminerSignup/ExaminerSignup")
  );
  const ExaminerDocumentUplaod = React.lazy(
    () => import("../components/ExaminerSignup/ExaminerDocumentUpload")
  );

  const Otp = React.lazy(() => import("../components/Otp/Otp"));
  const ForgotPassword = React.lazy(
    () => import("../components/Login/ForgotPassword")
  );
  const SetPassWord = React.lazy(
    () => import("../components/SetPassword/SetPassword")
  );
  const SubscriptionPlans = React.lazy(
    () => import("../components/SubscriptionPlans/SubscriptionPlans")
  );
  const UserSubscriptionPlans = React.lazy(
    () => import("../components/UserSubscriptionPlans/UserSubscriptionPlans")
  );

  const Dashboard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
  const ExamManagement = React.lazy(
    () => import("../pages/ExamManagement/ExamManagement")
  );
  const Chapter = React.lazy(() => import("../pages/Chapter/Chapter"));
  const Payment = React.lazy(() => import("../pages/Payment/Payment"));
  const Profile = React.lazy(() => import("../pages/Profile/Profile"));
  const joinexam = React.lazy(() => import("../pages/Joinexam/Joinexam"));
  const Examcompleted = React.lazy(
    () => import("../pages/Examcompleted/Examcompleted")
  );
  const Cms = React.lazy(() => import("../pages/Cms/Cms"));
  const Pages = React.lazy(() => import("../pages/Cms/AddCms"));
  const Users = React.lazy(() => import("../pages/User/User"));
  const AddUser = React.lazy(() => import("../pages/User/AddUser"));
  const Roles = React.lazy(() => import("../pages/Roles/Roles"));
  const AddRole = React.lazy(() => import("../pages/Roles/AddRole"));
  const StudyMaterials = React.lazy(
    () => import("../pages/StudyMaterials/StudyMaterials")
  );
  const AddStudyMaterials = React.lazy(
    () => import("../pages/StudyMaterials/AddStudyMaterial")
  );
  const Airport = React.lazy(() => import("../pages/Airport/Airport"));
  const AddAirport = React.lazy(() => import("../pages/Airport/AddAirport"));
  const Contact = React.lazy(() => import("../pages/Contact/Contact"));
  const Buy = React.lazy(() => import("../pages/Buy/Buy"));
  const BuyCertificate = React.lazy(
    () => import("../pages/BuyCertificate/BuyCertificate")
  );
     const CancelBooking = React.lazy(
    () => import("../pages/Cancel-Booking/Cancel-Booking")
  );
  const CertificationBooking = React.lazy(
    () => import("../pages/CertificationBooking/CertificationBooking")
  );

  const BuyStudyMaterial = React.lazy(
    () => import("../pages/BuyStudyMaterial/BuyStudyMaterial")
  );

  const About = React.lazy(() => import("../pages/About/About"));
  const Privacy = React.lazy(() => import("../pages/Privacy/Privacy"));
  const Examdetails = React.lazy(
    () => import("../pages/Examdetails/Examdetails")
  );
  const Terms = React.lazy(() => import("../pages/Terms/Terms"));
  const Subscription = React.lazy(
    () => import("../pages/Manage Subscription/Subscription")
  );
  const AddSubscription = React.lazy(
    () => import("../pages/Manage Subscription/AddSubscription")
  );
  const Payments = React.lazy(
    () => import("../pages/Manage Payments/Payments")
  );
  const Certificates = React.lazy(
    () => import("../pages/Certificates/Certificates")
  );
  const AddCertificates = React.lazy(
    () => import("../pages/Certificates/AddCertificate")
  );
  const Customers = React.lazy(() => import("../pages/Customers/Customers"));
  const AddCustomers = React.lazy(
    () => import("../pages/Customers/AddCustomer")
  );
  const ExamBookings = React.lazy(
    () => import("../pages/ExamBookings/ExamBookings")
  );
  const Examiners = React.lazy(() => import("../pages/Examiners/Examiners"));
  const Training = React.lazy(() => import("../pages/Website/Traning/Traning"));
  const Lesson = React.lazy(() => import("../pages/Website/Traning/Lesson"));
  const LessonDetail = React.lazy(
    () => import("../pages/Website/Traning/LessonDetail")
  );
  const Studydetails = React.lazy(
    () => import("../pages/Website/StudyMaterial/StudyDetails")
  );
  const ExaminerDetails = React.lazy(
    () => import("../pages/Examiners/ExaminerDetails")
  );
  const Flight = React.lazy(
    () => import("../pages/Website/FlightSimulator/Flight")
  );
  const Certifications = React.lazy(
    () => import("../pages/Website/Certifications/Certifications")
  );
  const CertificationDetails = React.lazy(
    () => import("../pages/Website/Certifications/CertificationDetails")
  );
  const Home = React.lazy(() => import("../pages/Website/Home/Home"));
  const ExaminerHome = React.lazy(
    () => import("../pages/ExaminerDashboard/ExaminerDashboard")
  );

  const ContactUs = React.lazy(
    () => import("../pages/Website/ContactUs/ContactUs")
  );
  const ContactsUs = React.lazy(() => import("../pages/ContactsUs/ContactsUs"));
  const TermAndCondition = React.lazy(
    () => import("../pages/term-and-condition/page")
  );

  const TermAndConditions = React.lazy(
    () => import("../pages/term-and-conditions/page")
  );
  const AboutUs  = React.lazy(
    () => import("../pages/about-us/page")
  );
   const PrivacyPolicy  = React.lazy(
    () => import("../pages/privacy-policy/page")
  );
  
  const EmailTemplates = React.lazy(
    () => import("../pages/EmailTemplates/Listing")
  );
  const AddEmailTemplates = React.lazy(
    () => import("../pages/EmailTemplates/AddTemplates")
  );
  const ExamConsole = React.lazy(
    () => import("../pages/ExamConsole/ExamConsole")
  );
  const VideoCall = React.lazy(() => import("../pages/ExamCall/ExamCall"));

  const SaveResult = React.lazy(() => import("../pages/saveResult/saveResult"));
  const ExaminerPayments = React.lazy(
    () => import("../pages/examinerPayments/examinerPayments")
  );
  const LiveIFRQuestion = React.lazy(
    () => import("../pages/LiveIFRQuestions/ExamLiveQuestions")
  );
  const LiveVFRQuestion = React.lazy(
    () => import("../pages/LiveVFRQuestions/ExamLiveQuestions")
  );
  const AddLiveIFRQuestion = React.lazy(
    () => import("../pages/LiveIFRQuestions/AddLiveQuestions")
  );
  const AddLiveVFRQuestion = React.lazy(
    () => import("../pages/LiveVFRQuestions/AddLiveQuestions")
  );

  const DemoIFRQuestion = React.lazy(
    () => import("../pages/DemoIFRQuestions/ExamDemoQuestions")
  );
  const DemoVFRQuestion = React.lazy(
    () => import("../pages/DemoVFRQuestions/ExamDemoQuestions")
  );
  const AddDemoIFRQuestion = React.lazy(
    () => import("../pages/DemoIFRQuestions/AddDemoQuestions")
  );
  const AddDemoVFRQuestion = React.lazy(
    () => import("../pages/DemoVFRQuestions/AddDemoQuestions")
  );


  const DiscountCode =   React.lazy(
    () => import("../pages/DiscountCodes/Listing")
  );

   const AddDiscountCode =   React.lazy(
    () => import("../pages/DiscountCodes/AddDiscount")
  );
  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/"
            element={
              isLoggedIn ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                {process.env.REACT_APP_USED_FOR === "examiner" ? (
                  <LoginExaminer />
                ) : (
                  <Login />
                )}
              </Suspense>
            }
          />
          <Route
            path="/signup"
            element={
              <Suspense fallback={<></>}>
                {process.env.REACT_APP_USED_FOR === "examiner" ? (
                  <SignupExaminer />
                ) : (
                  <Signup />
                )}
              </Suspense>
            }
          />
          <Route
            path="/document/upload/:uuid"
            element={
              <Suspense fallback={<></>}>
                <ExaminerDocumentUplaod />
              </Suspense>
            }
          />

          <Route
            path="/otp"
            element={
              <Suspense fallback={<></>}>
                <Otp />
              </Suspense>
            }
          />
          <Route
            path="/forgotPassword"
            element={
              <Suspense fallback={<></>}>
                <ForgotPassword />
              </Suspense>
            }
          />

          <Route
            path="/set-password"
            element={
              <Suspense fallback={<></>}>
                <SetPassWord />
              </Suspense>
            }
          />
          <Route
            path="/user-subscriptionplans"
            element={
              <Suspense fallback={<></>}>
                <UserSubscriptionPlans />
              </Suspense>
            }
          />
          <Route
            path="/term-and-condition"
            element={
              <Suspense fallback={<></>}>
                <TermAndCondition />
              </Suspense>
            }
          />
          <Route
            path="/term-and-conditions"
            element={
              <Suspense fallback={<></>}>
                <TermAndConditions />
              </Suspense>
            }
          />
      <Route
            path="/about-us"
            element={
              <Suspense fallback={<></>}>
                <AboutUs />
              </Suspense>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <Suspense fallback={<></>}>
                <PrivacyPolicy />
              </Suspense>
            }
          />
          <Route
            path="/attempts-app/:uuid"
            element={
              <Suspense fallback={<></>}>
                <TrainingAttemptPlayer />
              </Suspense>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          >
            <Route
              path="/exam-managements"
              element={
                <Suspense fallback={<></>}>
                  <ExamManagement />
                </Suspense>
              }
            />
            <Route
              path="/payment"
              element={
                <Suspense fallback={<></>}>
                  <Payment />
                </Suspense>
              }
            />
            <Route
              path="/profile"
              element={
                <Suspense fallback={<></>}>
                  <Profile />
                </Suspense>
              }
            />
            <Route
              path="/contactus"
              element={
                <Suspense fallback={<></>}>
                  <ContactUs />
                </Suspense>
              }
            />
            <Route
              path="/contact-us"
              element={
                <Suspense fallback={<></>}>
                  <ContactsUs />
                </Suspense>
              }
            />
            <Route
              path="/chapter"
              element={
                <Suspense fallback={<></>}>
                  <Chapter />
                </Suspense>
              }
            />
            <Route
              path="/joinexam"
              element={
                <Suspense fallback={<></>}>
                  <Joinexam />
                </Suspense>
              }
            />
            <Route
              path="/examcompleted"
              element={
                <Suspense fallback={<></>}>
                  <Examcompleted />
                </Suspense>
              }
            />
            <Route
              path="/mysubscription"
              element={
                <Suspense fallback={<></>}>
                  <Mysubscription />
                </Suspense>
              }
            />
            <Route
              path="/practise/:course_uuid"
              element={
                <Suspense fallback={<></>}>
                  <Practise />
                </Suspense>
              }
            />
            <Route
              path="/training"
              element={
                <Suspense fallback={<></>}>
                  <Training />
                </Suspense>
              }
            />
            <Route
              path="/training/lesson/:level_uuid"
              element={
                <Suspense fallback={<></>}>
                  <Lesson />
                </Suspense>
              }
            />
            <Route
              path="/training/lesson/detail/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <LessonDetail />
                </Suspense>
              }
            />
            <Route
              path="/studyMaterial"
              element={
                <Suspense fallback={<></>}>
                  <StudyMaterialDetails />
                </Suspense>
              }
            />
            <Route
              path="/studyDetails/:id"
              element={
                <Suspense fallback={<></>}>
                  <Studydetails />
                </Suspense>
              }
            />
            <Route
              path="/examiner-details/:id"
              element={
                <Suspense fallback={<></>}>
                  <ExaminerDetails />
                </Suspense>
              }
            />
            <Route
              path="/flight"
              element={
                <Suspense fallback={<></>}>
                  <Flight />
                </Suspense>
              }
            />
            <Route
              path="/manage-cms"
              element={
                <Suspense fallback={<></>}>
                  <Cms />
                </Suspense>
              }
            />
            <Route
              path="/pages/:id"
              element={
                <Suspense fallback={<></>}>
                  <Pages />
                </Suspense>
              }
            />
            <Route
              path="/manage-study-materials"
              element={
                <Suspense fallback={<></>}>
                  <StudyMaterials />
                </Suspense>
              }
            />
            <Route
              path="/study-material/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddStudyMaterials />
                </Suspense>
              }
            />
            <Route
              path="/manage-airports"
              element={
                <Suspense fallback={<></>}>
                  <Airport />
                </Suspense>
              }
            />
            <Route
              path="/airport/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddAirport />
                </Suspense>
              }
            />
             <Route
              path="/manage-countries"
              element={
                <Suspense fallback={<></>}>
                  <Countries />
                </Suspense>
              }
            />

               <Route
              path="/manage-simulators"
              element={
                <Suspense fallback={<></>}>
                  <Simulators />
                </Suspense>
              }
            />
             <Route
              path="/simulator-lesson/:levelId/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddSimulators />
                </Suspense>
              }
            />

            <Route
              path="/country/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddCountries />
                </Suspense>
              }
            />
            <Route
              path="/subscriptionplans"
              element={
                <Suspense fallback={<></>}>
                  <SubscriptionPlans />
                </Suspense>
              }
            />
            <Route
              path="/manage-exam-bookings"
              element={
                <Suspense fallback={<></>}>
                  <ExamBookings />
                </Suspense>
              }
            />
            <Route
              path="/manage-examiners"
              element={
                <Suspense fallback={<></>}>
                  <Examiners />
                </Suspense>
              }
            />
            <Route
              path="/manage-certificates"
              element={
                <Suspense fallback={<></>}>
                  <Certificates />
                </Suspense>
              }
            />
            <Route
              path="/certificate/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddCertificates />
                </Suspense>
              }
            />
            <Route
              path="/manage-subscription"
              element={
                <Suspense fallback={<></>}>
                  <Subscription />
                </Suspense>
              }
            />
            <Route
              path="/subscriptions/add"
              element={
                <Suspense fallback={<></>}>
                  <AddSubscription />
                </Suspense>
              }
            />
            <Route
              path="/subscriptions/edit/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddSubscription />
                </Suspense>
              }
            />
            <Route
              path="/user/subscriptions/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddUserSubscription />
                </Suspense>
              }
            />
             <Route
              path="/user/certificates/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddUserCertification />
                </Suspense>
              }
            />
            <Route
              path="/manage-payments"
              element={
                <Suspense fallback={<></>}>
                  <Payments />
                </Suspense>
              }
            />
            {/* <Route
              path="/settings"
              element={
                <Suspense fallback={<></>}>
                  <Settings />
                </Suspense>
              }
            /> */}
            <Route
              path="/course-levels/:id?"
              element={
                <Suspense fallback={<></>}>
                  <CourseManagement />
                </Suspense>
              }
            />
            <Route
              path="/questions"
              element={
                <Suspense fallback={<></>}>
                  <AddEditQuestion />
                </Suspense>
              }
            />
            <Route
              path="/levels/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddLevels />
                </Suspense>
              }
            />
            <Route
              path="/lessons/:id"
              element={
                <Suspense fallback={<></>}>
                  <CourseLessons />
                </Suspense>
              }
            />
            <Route
              path="/lesson/:levelId/add"
              element={
                <Suspense fallback={<></>}>
                  <Addlessons />
                </Suspense>
              }
            />
            <Route path="/lesson/edit/:levelId/:lessonId" element={<Addlessons />} />
            <Route
              path="/manage-customers"
              element={
                <Suspense fallback={<></>}>
                  <Customers />
                </Suspense>
              }
            />
            <Route
              path="/customer/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddCustomers />
                </Suspense>
              }
            />
            <Route
              path="/buy"
              element={
                <Suspense fallback={<></>}>
                  <Buy />
                </Suspense>
              }
            />
            <Route
              path="/buy-certificate"
              element={
                <Suspense fallback={<></>}>
                  <BuyCertificate />
                </Suspense>
              }
            />{" "}

             <Route
              path="/cancel-payment"
              element={
                <Suspense fallback={<></>}>
                  <CancelBooking />
                </Suspense>
              }
            />
            <Route
              path="/certification/:id/book"
              element={
                <Suspense fallback={<></>}>
                  <CertificationBooking />
                </Suspense>
              }
            />{" "}
            <Route
              path="/download-study-material"
              element={
                <Suspense fallback={<></>}>
                  <BuyStudyMaterial />
                </Suspense>
              }
            />
            <Route
              path="/manage-users"
              element={
                <Suspense fallback={<></>}>
                  <Users />
                </Suspense>
              }
            />
            <Route
              path="/user/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddUser />
                </Suspense>
              }
            />
            <Route
              path="/manage-roles"
              element={
                <Suspense fallback={<></>}>
                  <Roles />
                </Suspense>
              }
            />
            <Route
              path="/role/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddRole />
                </Suspense>
              }
            />
            <Route
              path="/examiner-payments"
              element={
                <Suspense fallback={<></>}>
                  <AdminExaminerPayments />
                </Suspense>
              }
            />
            <Route
              path="/home"
              element={
                <Suspense fallback={<></>}>
                  {userType === "EXAMINER" ? <ExaminerHome /> : <Home />}
                </Suspense>
              }
            />
            <Route
              path="/home"
              element={
                <Suspense fallback={<></>}>
                  <Home />
                </Suspense>
              }
            />
            <Route
              path="/certifications"
              element={
                <Suspense fallback={<></>}>
                  <Certifications />
                </Suspense>
              }
            />
            <Route
              path="/certification/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <CertificationDetails />
                </Suspense>
              }
            />
            <Route
              path="/setting"
              element={
                <Suspense fallback={<></>}>
                  <Settings />
                </Suspense>
              }
            />
            <Route
              path="/settings"
              element={
                <Suspense fallback={<></>}>
                  <ExaminerSettings />
                </Suspense>
              }
            />
            
            <Route
              path="/exam-console"
              element={
                <Suspense fallback={<></>}>
                  <ExamConsole />
                </Suspense>
              }
            />
            <Route
              id="live-ifr-route"
              path="/live-ifr-questions"
              element={
                <Suspense fallback={<></>}>
                  <LiveIFRQuestion />
                </Suspense>
              }
              handle={{ type: "IFR" }}
            />
            <Route
              path="/live-vfr-questions"
              element={
                <Suspense fallback={<></>}>
                  <LiveVFRQuestion />
                </Suspense>
              }
              handle={{ type: "VFR" }}
            />
            <Route
              path="/live-ifr-question/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddLiveIFRQuestion />
                </Suspense>
              }
            />
            <Route
              path="/live-vfr-question/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddLiveVFRQuestion />
                </Suspense>
              }
            />
            <Route
              id="live-ifr-route"
              path="/demo-ifr-questions"
              element={
                <Suspense fallback={<></>}>
                  <DemoIFRQuestion />
                </Suspense>
              }
              handle={{ type: "IFR" }}
            />
            <Route
              path="/demo-vfr-questions"
              element={
                <Suspense fallback={<></>}>
                  <DemoVFRQuestion />
                </Suspense>
              }
              handle={{ type: "VFR" }}
            />

                <Route
              path="/demo-ifr-question/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddDemoIFRQuestion />
                </Suspense>
              }
            />
            <Route
              path="/demo-vfr-question/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddDemoVFRQuestion />
                </Suspense>
              }
            />

            <Route
              path="/video-call"
              element={
                <Suspense fallback={<></>}>
                  <VideoCall />
                </Suspense>
              }
            />
            <Route
              path="/result/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <SaveResult />
                </Suspense>
              }
            />
            <Route
              path="/payments"
              element={
                <Suspense fallback={<></>}>
                  <ExaminerPayments />
                </Suspense>
              }
            />
            <Route
              path="/email-templates"
              element={
                <Suspense fallback={<></>}>
                  <EmailTemplates />
                </Suspense>
              }
            />
            <Route
              path="/template/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddEmailTemplates />
                </Suspense>
              }
            />
            <Route
              path="/contact"
              element={
                <Suspense fallback={<></>}>
                  <Contact />
                </Suspense>
              }
            />
            <Route
              path="/about"
              element={
                <Suspense fallback={<></>}>
                  <About />
                </Suspense>
              }
            />
            <Route
              path="/privacy"
              element={
                <Suspense fallback={<></>}>
                  <Privacy />
                </Suspense>
              }
            />
            <Route
              path="/terms"
              element={
                <Suspense fallback={<></>}>
                  <Terms />
                </Suspense>
              }
            />
            <Route
              path="/examdetails"
              element={
                <Suspense fallback={<></>}>
                  <Examdetails />
                </Suspense>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  <Dashboard />
                </Suspense>
              }
            />
            <Route
              path="/attempts/:uuid"
              element={
                <Suspense fallback={<></>}>
                  <TrainingAttemptPlayer />
                </Suspense>
              }
            />

             <Route
              path="/discount-codes"
              element={
                <Suspense fallback={<></>}>
                  <DiscountCode />
                </Suspense>
              }
            /> 

            <Route
              path="/discount-code/:id"
              element={
                <Suspense fallback={<></>}>
                  <AddDiscountCode />
                </Suspense>
              }
            /> 
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
